import validate from "/app/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@20.17.27_db0@0.3.1_encoding@0.1.13_ioredi_10179d20bf32ee2107d58082235c78fc/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@20.17.27_db0@0.3.1_encoding@0.1.13_ioredi_10179d20bf32ee2107d58082235c78fc/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "ensure-vehicle-model": () => import("/app/middleware/ensureVehicleModel.ts"),
  "reset-quote": () => import("/app/middleware/resetQuote.ts")
}